<template>
  <div>
   <div class="justify-center text-center my-3">
     <v-avatar
         class=" text-center mx-auto"
     >
       <v-img src="https://blog.cactusjack.top/upload/2022/09/arftt-mhkh6.jpg"></v-img>
     </v-avatar>
   </div>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item-group v-model="selectedItem">
        <v-list-item
            v-for="(item,index) in getRoutes"
            :key="index"
            link
            :exact="true"
            :to="item.path"
            v-show="!item.hidden"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "v-header",
  data: () => ({
    selectedItem: 0,
  }),
  computed: {
    ...mapGetters(['getDarker','getRoutes'])
  },
  mounted() {
    this.selectedItem = this.$router.getRoutes().findIndex(item => item.path === this.$route.path) | 0;
  }
}
</script>

<style scoped>

</style>
